export enum Concept {
  SITE = 'site',
  ASSET = 'asset',
  DEVICE = 'device',
  EVENT = 'event'
}
